import { z } from "zod";

export const credentialsSchema = z.object({
  email: z.string().trim().toLowerCase().email("E-mail invalido"),
  password: z.string().min(1, "Senha obrigatoria"),
});

export type CredentialsInput = z.infer<typeof credentialsSchema>;
